<div class="order-form-pulldown-wrapper">

  <nav class="custom-step-tabs" aria-label="Order progress">
    @for (label of StepLabels; track $index) {
    <button type="button" class="step-tab"
         [attr.aria-current]="stepper.selectedIndex === $index ? 'step' : null"
         [class.active]="stepper.selectedIndex === $index"
         [class.completed]="stepComplete($index)"
         (click)="stepper.selectedIndex = $index">
      <span class="step-tab-number">{{ $index + 1 }}</span>
      <span>{{ label }}</span>
      @if ($index === 3 && hasPendingPriceApproval) { <span class="step-state">Approval needed</span> }
    </button>
    @if ($index < StepLabels.length - 1) {
    <div class="step-connector" [class.completed]="$index < stepper.selectedIndex"></div>
    }
    }
  </nav>

  <div class="sticky-action-bar">
    <div class="action-bar-title-group">
      <div class="action-bar-heading"><span class="action-bar-title">{{ StepLabels[stepper.selectedIndex] }}</span><span class="action-bar-description">{{StepDescriptions[stepper.selectedIndex]}}</span></div>
      <span class="order-status">{{ hasPendingPriceApproval ? 'Pending Price Approval' : OrderStatusName }}</span>
      @if (stepper.selectedIndex === 1) {
      <rms-select label="Warehouse" [required]="true"
                  [options]="Warehouses"
                  labelKey="LocationName"
                  valueKey="LocationID"
                  [ngModel]="WarehouseSelection" [disabled]="WarehouseChanging"
                  (ngModelChange)="requestWarehouseChange($event)"
                  [ngModelOptions]="{standalone: true}">
      </rms-select>
      }
    </div>

    <div class="action-bar-buttons">
      @if (stepper.selectedIndex > 0) {
      <button class="btn-bg-red" mat-stroked-button type="button" (click)="stepper.previous()">Back</button>
      }
      <button class="btn-bg-blue" mat-stroked-button type="button" [disabled]="Saving || Submitting || !CustomerOrderForm.get('CompanyID')?.value" (click)="saveDraft()">{{ Saving ? 'Saving…' : 'Save Draft' }}</button>

      @if (stepper.selectedIndex === 0) {
      <button class="btn-bg-green" mat-flat-button type="button" [disabled]="!CustomerOrderForm.valid" (click)="stepper.next()">Continue</button>
      }
      @if (stepper.selectedIndex === 1) {
      <button class="btn-bg-green" mat-flat-button type="button" [disabled]="!stepComplete(1)" (click)="stepper.next()">Continue</button>
      }
      @if (stepper.selectedIndex === 2) {
      <button class="btn-bg-green" mat-flat-button type="button" [disabled]="!stepComplete(2)" (click)="stepper.next()">Continue</button>
      }
      @if (stepper.selectedIndex === 3) {
      <button class="btn-bg-green" mat-flat-button type="button" [disabled]="!requiredFieldsComplete" (click)="stepper.next()">Continue</button>
      }
      @if (stepper.selectedIndex === 4) {
      <button class="btn-bg-yellow" mat-stroked-button type="button" disabled
              title="Approval requests are not connected yet.">
        Request Price Approval
      </button>
      <button class="btn-bg-blue" mat-stroked-button type="button" disabled
              title="Invoice and payment emails are not connected yet.">
        Send Invoice / Payment
      </button>
      <button class="btn-bg-green" mat-flat-button type="button"
              [disabled]="!canSendToOutbound || Submitting || Saving"
              (click)="submitToOutbound()">
        {{ Submitting ? 'Processing…' : LiveBoardSubmission ? 'Submit to live board' : 'Send RNY Order' }}
      </button>

      @if (ActiveOrderID) {
      <button class="btn-bg-red" mat-stroked-button type="button" [disabled]="Submitting || Saving" (click)="cancelThisOrder()">
        Cancel Order
      </button>
      }
      }
    </div>
    @if (stepper.selectedIndex === 4) {
    <div class="review-submit-confirmation">
      <rms-checkbox [ngModel]="reviewApproved" (ngModelChange)="approveReview($event)" [ngModelOptions]="{standalone: true}" label="I have reviewed and approve this order for submission."></rms-checkbox>
      <span class="submission-guidance" [class.blocked]="!canSendToOutbound" role="status">{{ submissionBlockReason || 'Ready to submit. Changing order details requires a fresh review.' }}</span>
      @if (LiveBoardSubmission && CustomerOrderForm.get('PaymentMethodID')?.value !== 1 && !DatePaid) {
      <span class="board-submission-note">You can submit now; this order will wait for confirmed payment before outbound preparation.</span>
      }
    </div>
    }
  </div>

  @if (ActionError) {
  <div class="action-error" role="alert">{{ ActionError }}</div>
  }

  <mat-stepper #stepper [linear]="true" orientation="horizontal" [class.coffee-step]="stepper.selectedIndex === 1">

    <!-- Step 1: Customer & Order — compact, 2-column field layout -->
    <mat-step [stepControl]="CustomerOrderForm" label="Customer & Order">
      <div class="step-scroll-region">
        <form [formGroup]="CustomerOrderForm">
          <div class="step-fields-compact">

            @if (!CustomerLocked) {
            <rms-search-select formControlName="CompanyID" [required]="true"
                               label="Search By Customer ID or Name"
                               [options]="Customers"
                               labelKey="LabelName"
                               valueKey="CompanyID"
                               (selectionChange)="onCustomerSelected($event)"
                               class="span-2">
            </rms-search-select>
            }
            @if (CustomerLocked) {
            <div class="locked-customer-display span-2">
              <span class="muted">Customer</span>
              <strong>{{ SelectedCustomer?.CompanyName }}</strong>
            </div>
            }

            <rms-select formControlName="Trader" [required]="true" label="Trader" [options]="Traders" labelKey="FullName" valueKey="TraderID"></rms-select>
            <rms-select formControlName="OrderSource" [required]="true" label="Order Source" [options]="OrderSourceOptions" labelKey="label" valueKey="value"></rms-select>
            <rms-date formControlName="ProposedPickupDate" [required]="true" label="Requested Ship / Pickup Date"></rms-date>

            <div>
              <rms-select formControlName="Trucker" [required]="!ShippingDeliveryForm.get('CustomerPickup')?.value" label="Carrier / Trucker" [options]="Truckers" labelKey="TruckerName" valueKey="TruckerID"></rms-select>
              <!-- NEW (5.2.23): quick-add a carrier without leaving the order form -->
              @if (!AddingTrucker) {
              <button type="button" class="add-carrier-link" (click)="startAddTrucker()">+ Add new carrier</button>
              } @else {
              <div class="add-trucker-form">
              <input aria-label="Carrier name" placeholder="Carrier name" [(ngModel)]="NewTruckerName" [ngModelOptions]="{standalone: true}" />
                <button class="btn-bg-green" type="button" (click)="saveNewTrucker()">Save</button>
              </div>
              }
            </div>

            <rms-select formControlName="PaymentMethodID" [required]="true" label="Payment Method" [options]="PaymentMethods" labelKey="MethodName" valueKey="PaymentMethodID"></rms-select>
            <rms-select formControlName="PaymentTerms" label="Payment Terms" [options]="PaymentTerms" labelKey="PaymentTermName" valueKey="PaymentTermId"></rms-select>

          </div>

          @if (SelectedCustomer) {
          <div class="preloaded-defaults-inline">
            <span><strong>Address:</strong> {{ SelectedCustomer.ShippingStreet }}, {{ SelectedCustomer.ShippingCity }}, {{ SelectedCustomer.ShippingState }}</span>
            <span><strong>DO Instructions:</strong> {{ SelectedCustomer.LastDOInstructions ?? '—' }}</span>
          </div>
          <details class="customer-history">
            <summary>Customer order history ({{ CustomerOrders.length }})</summary>
            @if (HistoryLoading) { <p class="muted">Loading order history…</p> }
            @if (HistoryError) { <p role="alert">{{ HistoryError }}</p> }
            @if (!HistoryLoading && !HistoryError && CustomerOrders.length === 0) { <p class="muted">No prior orders found.</p> }
            @for (order of CustomerOrders; track order.OrderID) {
            <button mat-stroked-button type="button" (click)="viewPriorOrder(order.OrderID)">#{{ order.OrderID }} · {{ order.SaleDate | date:'mediumDate' }} · {{ order.StatusName }}</button>
            }
            @if (PriorOrder?.order) {
            <div class="prior-order">
              <strong>Order #{{ PriorOrder.order.OrderID }} · {{ PriorOrder.order.StatusName }}</strong>
              <p>{{ PriorOrder.order.WarehouseName }} · {{ PriorOrder.order.TruckerName }} · {{ PriorOrder.order.PaymentMethodName }}</p>
              @for (item of PriorOrder.lineItems; track item.InventoryID) {
              <p>Ref #{{ item.InventoryID }} · {{ item.InventoryTypeName }} · {{ item.NumberOfBags }} bags · {{ item.Price | currency }}/lb</p>
              }
              <p>Delivery instructions: {{ PriorOrder.order.WarehouseInstructions || '—' }}</p>
            </div>
            }
          </details>
          }
        </form>
      </div>
    </mat-step>

    <!-- Step 2: Coffee Selection -->
    <mat-step label="Coffee Selection" [completed]="OrderLineItems.length > 0">
      <div class="coffee-selection-split">

        <!-- Only THIS pane scrolls — offerings list -->
        <div class="offerings-scroll-region">
          <app-customer-reserves-orders #offeringsPicker [CompanyID]="SelectedCustomer?.CompanyID ?? null" [OrderID]="ActiveOrderID" [Warehouses]="Warehouses"
                                        [WarehouseNumber]="WarehouseNumber"
                                        [LineItems]="OrderLineItems"
                                        (onWarehouseChanged)="requestWarehouseChange($event)"
                                        (onLineItemsChanged)="onLineItemsChanged($event)">
          </app-customer-reserves-orders>
        </div>

        <aside class="cart-fixed-panel" aria-label="Current order">
          <div class="cart-heading"><div><span class="cart-eyebrow">ORDER SUMMARY</span><h4>{{SelectedCustomer?.CompanyName || 'Current order'}}</h4></div><span class="cart-count">{{OrderLineItems.length}}</span></div>
          <p class="cart-warehouse">{{selectedWarehouseName}}</p>
          <div class="cart-items-scroll">
            @if (!OrderLineItems.length) {
              <div class="cart-empty"><mat-icon aria-hidden="true">shopping_bag</mat-icon><strong>Your order starts here</strong><p>Add coffee from the list. Quantities and totals will stay visible as you browse.</p></div>
            }
            @for (item of OrderLineItems; track item.InventoryID) {
              <article class="cart-row">
                <div class="cart-product"><span class="cart-item-name">{{offeringsPicker.productName(item)}}</span><span class="cart-item-reference">Ref #{{item.InventoryID}} <span class="source-badge" [class.reserve]="item.ReserveOrderDetailID">{{item.ReserveOrderDetailID ? 'Reserved' : 'Spot'}}</span></span></div>
                <button class="cart-remove" mat-icon-button type="button" [attr.aria-label]="'Remove ' + offeringsPicker.productName(item)" (click)="offeringsPicker.removeFromOrder(item.InventoryID)"><mat-icon>close</mat-icon></button>
                <div class="cart-line-controls"><label><span>{{offeringsPicker.unitName(item) | titlecase}}</span><input type="number" required min="1" step="1" [max]="offeringsPicker.cartLimit(item)" [value]="item.NumberOfBags" [disabled]="offeringsPicker.Loading || !!offeringsPicker.LoadError" [attr.aria-label]="'Order quantity for reference ' + item.InventoryID" (focus)="offeringsPicker.selectOnFocus($event)" (change)="offeringsPicker.changeCartQuantity(item,$event)"></label><span class="cart-item-detail">{{item.Price | currency}} / lb<br>{{item.NetWeight | number:'1.0-2'}} lb / {{offeringsPicker.unitName(item,false)}}</span><strong class="cart-line-total">{{(offeringsPicker.lineTotal(item) | currency) || '—'}}</strong></div>
              </article>
            }
          </div>
          @if (offeringsPicker.CartError) {<p class="cart-feedback error" role="alert">{{offeringsPicker.CartError}}</p>}
          @if (offeringsPicker.CartMessage) {<p class="cart-feedback" role="status">{{offeringsPicker.CartMessage}}</p>}
          <div class="cart-totals">
            <div><span>Quantity</span><strong>{{totalBagsOnly}} bags@if(totalBoxes) { · {{totalBoxes}} boxes}</strong></div>
            @if (totalOrderWeight !== null) {<div><span>Net weight</span><strong>{{totalOrderWeight | number:'1.0-2'}} lb</strong></div>}
            <div class="coffee-subtotal"><span>Coffee subtotal</span><strong>{{(totalOrderAmount | currency) || '—'}}</strong></div>
            <small>Freight and other charges are not included.</small>
          </div>
        </aside>
      </div>
    </mat-step>

    <!-- Step 3: Shipping & Delivery — compact 2-column -->
    <mat-step [stepControl]="ShippingDeliveryForm" label="Shipping & Delivery">
      <div class="step-scroll-region">
        <form [formGroup]="ShippingDeliveryForm" class="shipping-form">
          <div class="readonly-context">
            <span><strong>Warehouse:</strong> {{ selectedWarehouseName }}</span>
            <span><strong>Carrier:</strong> {{ selectedTruckerName }}</span>
          </div>

          <!-- NEW (5.2 integration): the real, confirmed Pickup Date — separate
               from Step 1's ProposedPickupDate (the customer's originally
               requested date). blockedDates comes from onWarehouseChanged(),
               fed by the same /api/v1/outbound/capacity endpoint Outbound
               Management uses, so a trader sees the exact same closed dates
               Outbound would. Hard block, no override, per your manager. -->
          <div class="step-fields-compact">
            <rms-date formControlName="PickupDate"
                      label="Confirmed Pickup Date"
                      [blockedDates]="BlockedDates">
            </rms-date>
            <rms-input formControlName="TruckingQuote" label="Trucking Quote"></rms-input>
            <rms-input formControlName="ProNumber" label="PRO Number"></rms-input>
          </div>

          <div class="order-contact-addresses">
           <section><label>Billing contact *<select name="BillingAddressID" required [(ngModel)]="BillingAddressID" [ngModelOptions]="{standalone:true}" (ngModelChange)="selectContactAddress('Billing',$event)"><option [ngValue]="null">Select billing contact</option><option *ngFor="let a of contactOptions('Billing')" [ngValue]="a.CustomerShipToAddressID">{{contactLabel(a)}}</option></select></label><address *ngIf="BillingAddress">{{BillingAddress.Street}}<br>{{BillingAddress.City}}, {{BillingAddress.State}} {{BillingAddress.ZipCode}}</address></section>
           <section><label>Shipping contact *<select name="ShippingAddressID" required [(ngModel)]="ShippingAddressID" [ngModelOptions]="{standalone:true}" (ngModelChange)="selectContactAddress('Shipping',$event)"><option [ngValue]="null">Select shipping contact</option><option *ngFor="let a of contactOptions('Shipping')" [ngValue]="a.CustomerShipToAddressID">{{contactLabel(a)}}</option></select></label><address *ngFor="let a of ShippingAddresses">{{a.Street}}<br>{{a.City}}, {{a.State}} {{a.ZipCode}}</address></section>
          </div><p class="contact-help">Billing and shipping come from saved customer contacts in Roaster CRM → Billing &amp; Shipping. Existing orders retain their saved addresses until you select a replacement.</p>

          <div class="shipping-instructions">
            <rms-textarea formControlName="WarehouseInstructions" label="Delivery Order Instructions" resize="vertical"></rms-textarea>
            <rms-textarea formControlName="InvoiceInstructions1" label="Invoice Instructions" resize="vertical"></rms-textarea>
            <rms-textarea formControlName="InvoiceInstructions2" label="Additional Invoice Instructions" resize="vertical"></rms-textarea>
          </div>

          <div class="handling-checkboxes-row">
            <rms-checkbox formControlName="ShrinkWrap" label="Shrink Wrap"></rms-checkbox>
            <rms-checkbox formControlName="SlipSheet" label="Slip Sheets"></rms-checkbox>
            <rms-checkbox formControlName="Palletize" label="Palletize"></rms-checkbox>
            <rms-checkbox formControlName="MorningPickup" label="Morning Pickup"></rms-checkbox>
            <rms-checkbox formControlName="ReweighOrder" label="Reweight"></rms-checkbox>
            <rms-checkbox formControlName="CustomerPickup" label="Customer Pickup"></rms-checkbox>
          </div>
        </form>
      </div>
    </mat-step>

    <!-- Step 4: Payment & Validation -->
    <mat-step label="Payment & Validation" [completed]="requiredFieldsComplete">
      <div class="step-scroll-region">
        <div class="readonly-context">
          <span><strong>Payment Method:</strong> {{ selectedPaymentMethodName }}</span>
          <span><strong>Payment Terms:</strong> {{ selectedPaymentTermName }}</span>
        </div>

        <div class="validation-panel">
          <div class="validation-row" [class.validation-pass]="requiredFieldsComplete">
            {{ requiredFieldsComplete ? '✓' : '✗' }} Required customer, warehouse, and order fields complete
          </div>
          @if (!ActiveOrderID) {
          <div class="validation-row">Price validation runs automatically the next time you Save Draft or Submit.</div>
          }
          @if (ActiveOrderID && hasPendingPriceApproval) {
          <div class="validation-row validation-warn">
            ⚠ Last saved state shows a price outside approved range, requiring senior approval.
            <ul>
              @for (exception of PriceExceptions; track exception.OrderPriceExceptionID) {
              @if (exception.ApprovalStatus === 'Pending') {
              <li>Ref #{{ exception.InventoryID }} — entered {{ exception.EnteredPrice | currency }}/lb (range {{ exception.ApprovedMinPrice | currency }}–{{ exception.ApprovedMaxPrice | currency }}) · {{ exception.ApprovalStatus }}</li>
              }
              }
            </ul>
          </div>
          }
          @if (ActiveOrderID && !hasPendingPriceApproval && PriceExceptions.length > 0) {
          <div class="validation-row validation-pass">✓ All price exceptions resolved (as of last save)</div>
          }
        </div>
      </div>
    </mat-step>

    <!-- Step 5: Review & Submit -->
    <mat-step label="Review & Submit">
      <div class="step-scroll-region review-content">
        <div class="review-row">
          <span><strong>Customer</strong>{{ SelectedCustomer?.CompanyName ?? '—' }}</span>
          <span><strong>Trader</strong>{{ selectedTraderName }}</span>
          <span><strong>Warehouse</strong>{{ selectedWarehouseName }}</span>
          <span><strong>Payment</strong>{{ selectedPaymentMethodName }} · {{ selectedPaymentTermName }}</span>
        </div>

        <div class="validation-panel">
          <h4>Review checks</h4>
          @for (issue of validationIssues; track issue.message) {
          <div class="validation-row validation-warn">
            {{ issue.message }} <button mat-stroked-button type="button" (click)="stepper.selectedIndex = issue.step">Fix</button>
          </div>
          }
          @if (hasPendingPriceApproval) {
          <div class="validation-row validation-warn">Senior price approval is required. <button mat-stroked-button type="button" (click)="stepper.selectedIndex = 3">View exceptions</button></div>
          }
          @if (pricesNeedValidation) { <p class="muted">Prices will be validated when this order is saved. Any price requiring approval will block submission.</p> }
          @if (CustomerOrderForm.get('PaymentMethodID')?.value !== 1 && !DatePaid) { <p class="muted">Payment must be confirmed before this order can be sent to outbound.</p> }
        </div>

        <div class="review-row">
          <span><strong>Requested pickup</strong>{{ CustomerOrderForm.get('ProposedPickupDate')?.value | date:'mediumDate' }}</span>
          <span><strong>Confirmed pickup</strong>{{ (ShippingDeliveryForm.get('PickupDate')?.value | date:'mediumDate') || '—' }}</span>
          <span><strong>Carrier</strong>{{ selectedTruckerName }}</span>
          <span><strong>PRO number</strong>{{ ShippingDeliveryForm.get('ProNumber')?.value || '—' }}</span>
          <span><strong>Trucking quote</strong>{{ ShippingDeliveryForm.get('TruckingQuote')?.value || '—' }}</span>
        </div>
        <div class="review-shipping">
          <h4>Billing, delivery &amp; instructions</h4><div *ngIf="BillingAddress"><strong>Billing contact</strong><p>{{BillingAddress.ContactName || ((BillingAddress.FirstName || '')+' '+(BillingAddress.LastName || ''))}}<br>{{BillingAddress.Street}}<br>{{BillingAddress.City}}, {{BillingAddress.State}} {{BillingAddress.ZipCode}}</p></div>
          @for (address of ShippingAddresses; track $index) {
          <p><strong>{{ address.IsPrimary ? 'Primary address' : 'Additional address' }}</strong><br>{{ address.Street }}, {{ address.City }}, {{ address.State }} {{ address.ZipCode }} · {{ address.Country }}</p>
          }
          <p><strong>Delivery order instructions:</strong> {{ ShippingDeliveryForm.get('WarehouseInstructions')?.value || '—' }}</p>
          <p><strong>Invoice instructions:</strong> {{ ShippingDeliveryForm.get('InvoiceInstructions1')?.value || '—' }}</p>
          <p><strong>Additional invoice instructions:</strong> {{ ShippingDeliveryForm.get('InvoiceInstructions2')?.value || '—' }}</p>
          <div class="handling-summary">
            @for (option of ['ShrinkWrap', 'SlipSheet', 'Palletize', 'MorningPickup', 'ReweighOrder', 'CustomerPickup']; track option) {
            <span>{{ handlingLabel(option) }}: {{ ShippingDeliveryForm.get(option)?.value ? 'Yes' : 'No' }}</span>
            }
          </div>
        </div>

        @for (item of OrderLineItems; track item.InventoryID) {
        <div class="review-line-item">
          <span>{{ item.InventoryTypeName }}<small class="review-reference">Ref #{{item.InventoryID}} · {{item.ReserveOrderDetailID ? 'Reserved' : 'Spot'}}</small></span>
          <span>{{ item.NumberOfBags }} {{item.NetWeight === 22 ? 'boxes' : 'bags'}}</span>
          <span>{{ item.Price | currency }}/lb</span>
        </div>
        }
        <div class="review-total"><strong>{{ OrderLineItems.length }} items · {{ totalBagsOnly }} bags@if(totalBoxes) { · {{totalBoxes}} boxes}</strong><br>
          @if (totalOrderAmount !== null) { <span>Coffee subtotal: {{ totalOrderAmount | currency }}</span> }
          @else { <span class="muted">Coffee subtotal unavailable until all bag weights are known.</span> }
        </div>


        @if (!ActiveOrderID) {
        <p class="muted">Nothing has been saved yet — Save Draft or Send RNY Order will create this order.</p>
        }
      </div>
    </mat-step>

  </mat-stepper>

</div>
